import { lookupEntities } from '../../constants/metadataConstants';
import { getEntityOption } from '../../helpers/entityOptionHelper';

export const filterLookupBaseOptions = {
  [lookupEntities.FundraiserLookup]: {
    getItem(item) {
      return getEntityOption(item, {
        url: `${item.campaign.urlPath}/${item.urlPath}`
      });
    }
  },
  [lookupEntities.TeamLookup]: {
    getItem(item) {
      return getEntityOption(item, {
        url: `${item.campaign.urlPath}/${item.urlPath}`
      });
    }
  }
};
